import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';
import type { PitchSelectorOption } from './pitchSelection';

interface PitchSelectorProps {
  /** `byPitchOptions(...)` ou `byPositionOptions(...)`. */
  options: PitchSelectorOption[];
  /** Valor resolvido por `usePitchSelection`. */
  value: string | null;
  onChange: (value: string) => void;
  className?: string;
}

/**
 * "Pitch: <opção>" no cabeçalho das tabelas. Só aparece com 2 ou mais opções:
 * com 0 ou 1 pitch a tabela fica como antes.
 */
export function PitchSelector({ options, value, onChange, className }: PitchSelectorProps) {
  useLanguage();
  if (options.length < 2) return null;

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="text-[12px] font-medium text-[#5A6475]">{translateInterfaceText("Pitch:")}</span>
      <Select value={value ?? options[0].value} onValueChange={onChange}>
        <SelectTrigger aria-label={translateInterfaceText("Escolher pitch")} className="h-8 w-[170px] bg-white text-[12px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value} className="text-[12px]">
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
